﻿window.information = function () {

    return {

        initialize: function () { },

        initialize_EditInfo: function () { },

        TAB_ExtraInfo_editButtonClicked: function (nodeId) {
            // load edit view
            navigation.navigateToSpecificUrl("Information/Edit?nodeId=" + nodeId);
        },


        onImageChanged: function (e) {

            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Information/GetImage"),
                data: { figureId: e.sender.element[0].value },
                success: function (responseData) {

                    var btn = $("#deleteButton");
                    var image = $("#figureImage");
                    if (image != null && image != undefined && responseData != null && responseData != "") {
                        image.attr("src", responseData);
                        image.removeAttr("hidden");
                        btn.removeAttr("disabled");
                    } else {
                        image.attr("hidden", "hidden");
                        btn.attr("disabled", "disabled");
                    }

                }
            });            
        },


        onDeleteButtonClicked: function (e) {

            var cbb = $("#ImgID").data("kendoDropDownList");
            cbb.value(null);
            cbb.trigger("change");
        },
        
    }
}();